
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/kyc-aml",
      function () {
        return require("private-next-pages/docs/kyc-aml.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/kyc-aml"])
      });
    }
  